/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetAccountManagerTypes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountManagerTypesRequest = createAction<PayloadData<void>>('GET_ACCOUNT_MANAGER_TYPES__GET_ACCOUNT_MANAGER_TYPES__REQUEST');
export const getAccountManagerTypesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_ACCOUNT_MANAGER_TYPES__GET_ACCOUNT_MANAGER_TYPES__SUCCESS');
export const getAccountManagerTypesFailure = createAction<PayloadData<Error, void, true>>('GET_ACCOUNT_MANAGER_TYPES__GET_ACCOUNT_MANAGER_TYPES__FAILURE');

export const getAccountManagerTypesActions = [
    getAccountManagerTypesRequest,
    getAccountManagerTypesSuccess,
    getAccountManagerTypesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountManagerTypes = (config?: GetAccountManagerTypes$Config) => {
    return {
        CALL_API: {
            types: getAccountManagerTypesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/manager-type`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

